import { Directive, TemplateRef } from '@angular/core';

/**
 * Report parameters definition for an NDT report.
 * Captures the template of the report parameters to be rendered in a dialog.
 */
@Directive({
    selector: '[ndtReportParametersDef]',
    standalone: false
})
export class ReportParametersDefDirective {
   constructor(public templateRef: TemplateRef<never>) {}
}
